/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
export default function ProviderDropdown({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    options,
    data_testid,
    handleReadingTypeSelect,
    sendalertDetails,

}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()

    const buttonRef = useRef(null);

    const dropdownRef = useRef(null)
    const [isOpen, setisOpen] = useState(false);


    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });


    return (
        <>
            <div className='relative' ref={ref}>
                <p htmlFor='countryCode' className='text-xs  font-semibold text-[#000] pb-1.5 '>{label}</p>
                <button ref={buttonRef} id="monitor_list" data-testid="recipient_list" onClick={() => { setisOpen(!isOpen) }} className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[12px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} disabled={disabled}>
                    <p id={id} className={`${(value === "" || value === undefined || value === true) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(value === "" || value === undefined || value === true)
                        ? placeholder
                        : value}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[9] absolute top-[52px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                {options && options.length > 0 ?
                                    <ul className={`max-h-[320px] overflow-auto scrollbar_gray pr-3`}>
                                        {
                                            options && options?.map((item, idx) => (
                                                <li key={idx} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                                    <div className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            id={item.providerUserData.user_id}
                                                            onChange={() => handleReadingTypeSelect(item.providerUserData.user_id)}
                                                            checked={sendalertDetails?.recepient_details?.includes(item.providerUserData.user_id)}
                                                        />
                                                        <label
                                                            title={(item.providerUserData?.first_name || '') + " " + (item.providerUserData?.last_name || '') + " " + item.providerUserData.user_id}
                                                            htmlFor={item.providerUserData.user_id}
                                                            id={'provider'}
                                                            data-testid={`select-recipient-${idx}`}
                                                            className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                                        >{item.providerUserData?.first_name || ''} {item.providerUserData?.last_name || ''} {item.providerUserData.user_id}</label>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    :
                                    <p className="mt-2 text-center">No results found</p>
                                }
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </>
    )
}
